<script setup>
import { computed, watch, ref } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { useAccount } from 'dashboard/composables/useAccount';
import { useI18n } from 'vue-i18n';

import AccountAPI from 'dashboard/api/account';
import Banner from 'dashboard/components-next/banner/Banner.vue';

const currentUser = useMapGetter('getCurrentUser');
const { accountId } = useAccount();
const { t } = useI18n();

const smsAlert = ref({ alert: false });

const fetchAlert = async () => {
  if (!currentUser.value?.id || !accountId.value) return;

  try {
    const { data } = await AccountAPI.getSmsAlert(accountId.value);
    smsAlert.value = data;
  } catch {
    smsAlert.value = { alert: false };
  }
};

watch([accountId, currentUser], fetchAlert, { immediate: true });

const showBanner = computed(() => smsAlert.value?.alert);

const bannerColor = computed(() => {
  const level = smsAlert.value?.level;
  if (level === 'blocked' || level === 'critical') return 'ruby';

  return 'amber';
});

const bannerMessage = computed(() => {
  const level = smsAlert.value?.level;
  const messageKey = {
    warning: 'GENERAL_SETTINGS.SMS_ALERT.WARNING',
    critical: 'GENERAL_SETTINGS.SMS_ALERT.CRITICAL',
    blocked: 'GENERAL_SETTINGS.SMS_ALERT.BLOCKED',
  }[level];

  return messageKey ? t(messageKey) : '';
});
</script>

<template>
  <Banner
    v-if="showBanner"
    :color="bannerColor"
    class="!rounded-none !justify-center"
  >
    <span class="text-xs">{{ bannerMessage }}</span>
  </Banner>
</template>
